// document.addEventListener('DOMContentLoaded', () => {
//   const headerSection = document.querySelector('.header-section');
//   const headerGroup = document.getElementById('header-group');

//   if (!headerSection || !headerGroup) return;

//   headerSection.addEventListener('mouseenter', () => {
//     headerGroup.classList.add('header-white');
//   });

//   headerSection.addEventListener('mouseleave', () => {
//     headerGroup.classList.remove('header-white');
//   });
// });

// document.addEventListener('change', async function (event) {
//   if (event.target.id !== 'split-shipping-checkbox') return;

//   const checkbox = event.target;

//   // Prevent theme cart scripts from handling this checkbox
//   event.stopImmediatePropagation();

//   const variantId = Number(checkbox.dataset.splitShippingVariant);

//   if (!variantId) {
//     console.error('Split shipping variant ID missing');
//     return;
//   }

//   checkbox.disabled = true;

//   try {
//     if (checkbox.checked) {
//       // Get current cart first
//       const cart = await fetch('/cart.js', {
//         headers: {
//           'Accept': 'application/json'
//         }
//       }).then(response => response.json());

//       const splitItem = cart.items.find(
//         item => item.variant_id === variantId
//       );

//       // Only add if it doesn't already exist
//       if (!splitItem) {
//         await fetch('/cart/add.js', {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//             'Accept': 'application/json'
//           },
//           body: JSON.stringify({
//             id: variantId,
//             quantity: 1
//           })
//         });
//       }
//     } else {
//       // Remove split shipping product
//       const cart = await fetch('/cart.js', {
//         headers: {
//           'Accept': 'application/json'
//         }
//       }).then(response => response.json());

//       const splitItem = cart.items.find(
//         item => item.variant_id === variantId
//       );

//       if (splitItem) {
//         await fetch('/cart/change.js', {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//             'Accept': 'application/json'
//           },
//           body: JSON.stringify({
//             id: splitItem.key,
//             quantity: 0
//           })
//         });
//       }
//     }

//     // Refresh cart sections
//     const response = await fetch(
//       '/cart?sections=main-cart,cart-icon-bubble'
//     );

//     const data = await response.json();

//     // Update cart content
//     const cartSection = document.querySelector('#main-cart');

//     if (cartSection && data['main-cart']) {
//       cartSection.innerHTML = data['main-cart'];
//     }

//     // Update cart bubble
//     const cartBubble = document.querySelector('#cart-icon-bubble');

//     if (cartBubble && data['cart-icon-bubble']) {
//       cartBubble.innerHTML = data['cart-icon-bubble'];
//     }

//   } catch (error) {
//     console.error('Split shipping error:', error);

//     checkbox.checked = !checkbox.checked;

//   } finally {
//     checkbox.disabled = false;
//   }
// });



document.addEventListener('change', async function (event) {
  if (event.target.id !== 'split-shipping-checkbox') return;

  const checkbox = event.target;
  event.stopImmediatePropagation();

  await updateSplitShipping(checkbox);
});


async function updateSplitShipping(checkbox) {
  const variantId = Number(checkbox.dataset.splitShippingVariant);

  if (!variantId) {
    console.error('Split shipping variant ID missing');
    return;
  }

  checkbox.disabled = true;

  try {
    const cart = await getCart();

    const splitItem = cart.items.find(
      item => item.variant_id === variantId
    );

    if (checkbox.checked) {

      if (!splitItem) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        });
      }

    } else {

      if (splitItem) {
        await removeCartItem(splitItem.key);
      }

    }

    await refreshCart();

  } catch (error) {
    console.error('Split shipping error:', error);
    checkbox.checked = !checkbox.checked;

  } finally {
    checkbox.disabled = false;
  }
}


async function getCart() {
  return await fetch('/cart.js', {
    headers: {
      Accept: 'application/json'
    }
  }).then(res => res.json());
}


async function removeCartItem(key) {
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: key,
      quantity: 0
    })
  });
}


async function refreshCart() {

  const response = await fetch(
    '/cart?sections=main-cart,cart-icon-bubble'
  );

  const data = await response.json();

  const cartSection = document.querySelector('#main-cart');

  if (cartSection && data['main-cart']) {
    cartSection.innerHTML = data['main-cart'];
  }

  const cartBubble = document.querySelector('#cart-icon-bubble');

  if (cartBubble && data['cart-icon-bubble']) {
    cartBubble.innerHTML = data['cart-icon-bubble'];
  }
}


/**
 * Auto remove split shipping product
 * when cart no longer has:
 * - pre-order product
 * - regular product
 */
document.addEventListener(
  'cart:updated',
  async function () {

    const splitVariantId = 53618558665069;

    const cart = await getCart();

    let hasPreOrder = false;
    let hasRegular = false;
    let splitItem = null;


    cart.items.forEach(item => {

      if (item.variant_id === splitVariantId) {
        splitItem = item;
        return;
      }


      if (item.product_type || item.tags) {

        if (item.tags.includes('pre-order')) {
          hasPreOrder = true;
        } else {
          hasRegular = true;
        }

      }

    });


    if ((!hasPreOrder || !hasRegular) && splitItem) {

      await removeCartItem(splitItem.key);

      await refreshCart();

    }

  }
);